// extracted by mini-css-extract-plugin
export default {"button":"Dj-z","reviewSort":"Ej-z"};